export enum LunchPreference {
    DYNAMIC = "DYNAMIC",
    FIXED_1_30 = "FIXED_1_30",
    FIXED_2_30 = "FIXED_2_30",
    NONE = "NONE",
}
